<template>
  <div id="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item class="index_txt" :to="{ path: '/' }"
        ><i class="el-icon-house"></i>&nbsp;系统首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ systitle }}</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">{{
        item.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in thirdList" :key="index">{{
        item.name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import Config from "@/utils/config";
import NavConfig from "@/utils/navconfig";
export default {
  name: "Breadcrumb",
  data() {
    return {
      systitle: "",
      breadList: [],
      thirdList: [],
      nowLeftNav: [],
    };
  },
  mounted() {
    this.setSystitle();
  },
  methods: {
    getBreadcrumb(n) {
      let breadList = [];
      let thirdList = [];
      let nowLeftNav = this.nowLeftNav;
      if (n == 0) {
        breadList.push({ name: nowLeftNav[0].name });
        if (nowLeftNav[0].children) {
          breadList.push({ name: nowLeftNav[0].children[0].name });
          if (nowLeftNav[0].children[0].children) {
            thirdList.push({ name: nowLeftNav[0].children[0].name });
          }
        }
      } else {
        // 循环主系统名称
        for (let i = 0; i < nowLeftNav.length; i++) {
          let mainNav = this.$store.state.mainNav;
          if (
            nowLeftNav[i].moduleType == n ||
            nowLeftNav[i].moduleType.replace(mainNav.replace(mainNav[0], mainNav[0].toUpperCase()),"") == n
          ) {
            breadList.push({ name: nowLeftNav[i].name });
            break;
          }
        }
        // 循环侧边栏
        if (breadList.length <= 0) {
          let f = true;
          for (let i = 0; i < nowLeftNav.length; i++) {
            if (nowLeftNav[i].children) {
              for (let j = 0; j < nowLeftNav[i].children.length; j++) {
                if (nowLeftNav[i].children[j].children) {
                  for (
                    let x = 0;
                    x < nowLeftNav[i].children[j].children.length;
                    x++
                  ) {
                    if (nowLeftNav[i].children[j].children[x].moduleType == n) {
                      breadList.push({ name: nowLeftNav[i].name });
                      breadList.push({ name: nowLeftNav[i].children[j].name });
                      thirdList.push({
                        name: nowLeftNav[i].children[j].children[x].name,
                      });
                      f = false;
                      break;
                    }
                  }
                } else if (nowLeftNav[i].children[j].moduleType == n) {
                  breadList.push({ name: nowLeftNav[i].name });
                  breadList.push({ name: nowLeftNav[i].children[j].name });
                  f = false;
                  break;
                }
              }
              if (f == false) {
                break;
              }
            }
          }
        }
      }
      this.breadList = breadList;
      this.thirdList = thirdList;
    },
    setSystitle() {
      let mainNav = this.$store.state.mainNav;
      let topNav = Config.topNav;
      for (let i = 0; i < topNav.length; i++) {
        if (mainNav == topNav[i].name) {
          this.systitle = topNav[i].text;
          break;
        }
      }
      console.log(mainNav,'mainNav11' )
      this.nowLeftNav = NavConfig[mainNav + "Nav"];
      console.log(this.nowLeftNav,' this.nowLeftNav ' )
      this.getBreadcrumb(0);
    },
  },
  watch: {
    "$store.state.leftNav": {
      handler: function (newVal, oldVal) {
        this.getBreadcrumb(newVal);
        if (newVal != oldVal) {
          this.comName = newVal;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#breadcrumb {
  width: 100%;
  height: 50px;
  background-color: #fff;
  padding-left: 30px;
  box-sizing: border-box;

  .el-breadcrumb {
    line-height: 50px;
    font-size: 14px;
  }
  ::v-deep .el-breadcrumb__inner.is-link {
    font-weight: normal;
  }
  ::v-deep .index_txt .el-breadcrumb__inner.is-link {
    font-weight: 700;
  }

  ::v-deep .el-breadcrumb__inner a:hover,
  ::v-deep .el-breadcrumb__inner.is-link:hover {
    color: #376bf4;
  }
}
</style>